import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';

const useAccountUnlockScreen = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isServerError, setIsServerError] = useState(false);
  const [userType, setUserType] = useState('');
  const { adminConfigData = {} } = useSelector((state) => state.user || {});
  const { AccountUnLockConfiguration } = adminConfigData?.Response || {};

  const navigate = useNavigate();
  const location = useLocation();
  const emailValue = location?.state?.email || '';
  const headingRef = useRef(null);

  const fetchMemberInfo = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `${APIEndpoints.getUserAvailability()}/rruserid/${emailValue}`,
      );

      setUserType(response?.data?.Response?.UserType);

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setIsServerError(true);
      console.log(e);
    }
  };

  useEffect(() => {
    fetchMemberInfo();
  }, []);

  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [isLoading]);

  return {
    emailValue,
    EnableSelfUnlock: AccountUnLockConfiguration?.EnableSelfUnlock,
    EligiblePersona:
      userType === 'Employee'
        ? AccountUnLockConfiguration?.MemberEnabled
        : AccountUnLockConfiguration?.DependentEnabled,
    isLoading,
    isServerError,
    navigate,
    headingRef,
  };
};

export default useAccountUnlockScreen;
